import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-nav-tile',
  imports: [RouterLink],
  templateUrl: './nav-tile.component.html',
  styleUrl: './nav-tile.component.scss'
})
export class NavTileComponent {
  @Input() icon = '';
  @Input() label = '';
  @Input() subtitle = '';
  @Input({ required: true }) path!: string;
}
